import React, { Component } from 'react';

class Dashboard extends Component {
    render() {
        return (
            <div>
                <p>hola mundo</p>
            </div>
        );
    }
}

export default Dashboard;